import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from '@deliveroo/consumer-component-library/components/Modal';
import ZendeskChat from '../ZendeskChat';
import OrderHelpIntroContainer from '../OrderHelpIntro';
import OrderHelpTemplateContainer from '../OrderHelpTemplateContainer';
import { OrderHelpIframeModal } from '../../components/OrderHelpIframe';

import { setOrderHelpModalIsOpen } from '../../actions/orderActions';

import { EMPTY_STATE } from '../OrderHelpTemplateContainer/templateTypes';

import i18n from '../../utils/i18n';

import { getOrderHelp, getOrderHelpModalState } from '../../selectors/orderHelpSelectors';
import { CX_OH_NON_IFRAME } from '../../flags/features';
import { isFeatureActive } from '../../selectors/configSelectors';

export class OrderHelpModalContainer extends Component {
  componentDidMount() {
    window.closeSelfHelp = () => this.props.setOrderHelpModalIsOpen(false);
  }

  render() {
    let modalTitle = this.props.helpTitle || i18n.gettext('order_status_page.order_help');
    if (this.props.templateType === EMPTY_STATE) {
      modalTitle = i18n.gettext('order_help.error_loading_shs.title');
    }

    return (
      <Fragment>
        {!this.props.nonIframeSelfHelpFeatureOn && (
          <OrderHelpIframeModal
            isOpen={this.props.isOpen}
            onModalOpen={() => {
              this.props.setOrderHelpModalIsOpen(true);
            }}
            onModalClose={() => {
              this.props.setOrderHelpModalIsOpen(false);
            }}
            contentLabel="Order help"
            title="Order help"
            iframeUrl={this.props.iframeUrl}
            hasTransparentIframeBackground={this.props.hasTransparentIframeBackground}
          />
        )}

        {this.props.nonIframeSelfHelpFeatureOn && (
          <Modal
            id="order-help-modal"
            appElement={this.props.appElement}
            type="fullscreen"
            isOpen={this.props.isOpen}
            onClose={() => {
              this.props.setOrderHelpModalIsOpen(false);
            }}
            closeButtonLabel={i18n.gettext('closeButton.label')}
            headerTitle={modalTitle}
            renderFooter={() => <div>Footer buttons</div>}
          >
            <OrderHelpIntroContainer />

            <OrderHelpTemplateContainer />
          </Modal>
        )}

        <ZendeskChat />
      </Fragment>
    );
  }
}

OrderHelpModalContainer.defaultProps = {
  appElement: '#__next',
  isOpen: false,
  helpTitle: '',
  templateType: '',
  hasTransparentIframeBackground: false,
  nonIframeSelfHelpFeatureOn: false,
  setOrderHelpModalIsOpen: () => {},
};

OrderHelpModalContainer.propTypes = {
  /**
   * If there is a modal, where the modal renders
   */
  appElement: PropTypes.string,
  /**
   * Whether the OrderHelpModal is open or not
   */
  isOpen: PropTypes.bool,
  /**
   * The title of the self help page
   */
  helpTitle: PropTypes.string,
  /**
   * The template that self help is currently showing
   */
  templateType: PropTypes.string,
  /**
   * The help page to load into the iframe
   */
  iframeUrl: PropTypes.string.isRequired,
  /**
   * TODO: This `hasTransparentIframeBackground` is a bit hacky as it's related to
   * whether there's only a dialog template (see `isDialogOnlyHelpPage` prop).
   * This will be cleaned up when we move away from iframes.
   */
  hasTransparentIframeBackground: PropTypes.bool,
  /**
   * Feature flag: whether to use non-iframe self help (needed for order web order history page)
   * or CCL Dialog component self help (when order history is moved to CWA)
   */
  nonIframeSelfHelpFeatureOn: PropTypes.bool,
  /**
   * Action to open/close the OrderHelpModal
   */
  setOrderHelpModalIsOpen: PropTypes.func,
};

export const mapStateToProps = (state) => {
  const { id: orderId, title, type, isSpecificHelpPage } = getOrderHelp(state);
  const {
    isOpen,
    selectedActionId,
    selectedActionTemplate,
    actionId,
    actionTemplate,
  } = getOrderHelpModalState(state);

  let iframeUrl = `/orders/${orderId}/help?iframe=true`;
  if (actionId && actionTemplate && selectedActionId && selectedActionTemplate) {
    iframeUrl += `&daai=${actionId}&daat=${actionTemplate}&dasai=${selectedActionId}&dasat=${selectedActionTemplate}`;
  }

  return {
    isOpen,
    iframeUrl,
    helpTitle: title,
    templateType: type,
    hasTransparentIframeBackground: Boolean(
      isSpecificHelpPage && selectedActionId === 'contact_rider_unavailable',
    ),
    nonIframeSelfHelpFeatureOn: isFeatureActive(state, CX_OH_NON_IFRAME),
  };
};

const mapActionsToProps = (dispatch) => ({
  setOrderHelpModalIsOpen: (isOpen) => dispatch(setOrderHelpModalIsOpen(isOpen)),
});

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(OrderHelpModalContainer);
